import { useMemo } from "react";
import dayjs from "dayjs";
import { useAuth } from "@/context/AuthContext";
import { Sel } from "@/components/common";

export const PRESETS = {
  today: () => [dayjs(), dayjs()],
  yesterday: () => [dayjs().subtract(1, "day"), dayjs().subtract(1, "day")],
  week: () => [dayjs().startOf("week").add(1, "day"), dayjs()],
  month: () => [dayjs().startOf("month"), dayjs().endOf("month")],
  last30: () => [dayjs().subtract(29, "day"), dayjs()],
  quarter: () => [dayjs().subtract(89, "day"), dayjs()],
};

export const defaultFilters = (preset = "month", extra = {}) => ({ preset, vertical: "", source: "", stage: "", user_id: "", from: "", to: "", ...extra });

export const toParams = (f) => {
  const [a, b] = f.preset === "custom" ? [dayjs(f.from || undefined), dayjs(f.to || f.from || undefined)] : PRESETS[f.preset]();
  const p = { date_from: a.format("YYYY-MM-DD"), date_to: b.format("YYYY-MM-DD") };
  ["vertical", "source", "stage", "user_id"].forEach((k) => { if (f[k]) p[k] = f[k]; });
  return p;
};

export const FilterBar = ({ value, onChange, show = ["date", "vertical", "source", "stage", "user"] }) => {
  const { meta, isAdmin, salesUsers } = useAuth();
  const set = (k) => (v) => onChange({ ...value, [k]: v });
  const users = useMemo(() => salesUsers.map((u) => ({ value: u.id, label: u.name })), [salesUsers]);
  if (!meta) return null;
  return (
    <div className="crm-card mb-6 flex flex-wrap items-end gap-3 p-3" data-testid="filter-bar">
      {show.includes("date") && (
        <div className="w-36">
          <Sel testid="filter-date-preset" value={value.preset} onChange={set("preset")} options={[
            { value: "today", label: "Today" }, { value: "yesterday", label: "Yesterday" }, { value: "week", label: "This week" },
            { value: "month", label: "This month" }, { value: "last30", label: "Last 30 days" }, { value: "quarter", label: "Last 90 days" },
            { value: "custom", label: "Custom range" }]} />
        </div>
      )}
      {show.includes("date") && value.preset === "custom" && (
        <>
          <input type="date" data-testid="filter-date-from" className="crm-input w-40" value={value.from} onChange={(e) => set("from")(e.target.value)} />
          <input type="date" data-testid="filter-date-to" className="crm-input w-40" value={value.to} onChange={(e) => set("to")(e.target.value)} />
        </>
      )}
      {show.includes("user") && isAdmin && (
        <div className="w-44"><Sel testid="filter-salesperson" value={value.user_id} onChange={set("user_id")} placeholder="All salespeople" options={users} /></div>
      )}
      {show.includes("vertical") && (
        <div className="w-36"><Sel testid="filter-vertical" value={value.vertical} onChange={set("vertical")} placeholder="All verticals" options={meta.verticals} /></div>
      )}
      {show.includes("source") && (
        <div className="w-40"><Sel testid="filter-source" value={value.source} onChange={set("source")} placeholder="All sources" options={meta.sources} /></div>
      )}
      {show.includes("stage") && (
        <div className="w-44"><Sel testid="filter-stage" value={value.stage} onChange={set("stage")} placeholder="All stages" options={meta.stages} /></div>
      )}
      <button data-testid="filter-reset" onClick={() => onChange(defaultFilters(value.preset))} className="h-9 px-2 text-xs font-semibold text-muted-foreground hover:text-primary">Reset</button>
    </div>
  );
};
